/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { EntityStore } from 'src/core/types/EntityStore';

export class CustomTextExtractionStore {
    @observable public entities: EntityStore[];

    constructor(entities: EntityStore[]) {
        this.entities = entities;
    }

    /**
     * Adds a new entity to the extraction store
     * @param name name of the new entity
     */
    @action
    public addEntity(name: string) {
        this.entities.push(new EntityStore({ name }));
    }

    /**
     * Deletes a number of entities by their Ids
     * @param entityIds Ids of entities to be deleted
     */
    @action
    public deleteEntitiesByIds(entityIds: string[]) {
        this.entities = this.entities.filter(e => !entityIds.includes(e.id));
    }

    /**
     * Renames an entity by Id
     * @param param0
     */
    @action
    public renameEntityById({ id, newName }: { id: string; newName: string }) {
        this.entities.find(e => e.id === id).renameEntity(newName);
    }
}
